import { gsap } from 'gsap';

export default class HomeHeroGrow {
    constructor() {
        this.settings = {
            $growImage: $('#home-hero-image'),
        };

        this.bindUIActions();
    }

    bindUIActions() {
        if (this.settings.$growImage.length) {
            const headerHeight = $('.header').outerHeight();

            const growTl = gsap.timeline({
                scrollTrigger: {
                    trigger: '#home-hero-image',
                    pin: '.home-hero-wrapper',
                    scrub: true,
                    start: 'top-=' + headerHeight + ' top',
                    end: '+=700',
                    ease: 'power1.out',
                },
            });

            growTl.to('#home-hero-image', {
                duration: 1,
                scale: 1.2,
            });
        }
    }
}

new HomeHeroGrow();
